export enum InternalTypeEnum {
	Menu = 1,
	Short = 2,
	Long = 3,
	Decimal = 4,
	Float = 5,
	Double = 6,
	Alpha = 7,
	Date = 8,
	Blob = 9,
	Clob = 10,
	Uuid = 11,
	Datetime = 12
}
